import React from 'react'
import { ReactComponent as Detail1Svg } from './icons/detail-1.svg'
import { ReactComponent as Detail2Svg } from './icons/detail-2.svg'
import { ReactComponent as Detail3Svg } from './icons/detail-3.svg'
import { ReactComponent as UploadSvg } from './icons/upload.svg'
import { ReactComponent as NoticeSvg } from './icons/notice.svg'
import { ReactComponent as SendTaskSvg } from './icons/send-work.svg'
import { ReactComponent as CloseSvg } from './icons/close.svg'
import './index.less'
import { DetailType } from '@/commons/enums/detail-type'
import ObjectDetailPanel from './object-detail'
import InfoElementPanel from './element'
import NoticePanel from './notice'
import SendWorkPanel from './work-order/ceate'
import InspectPanel from './inspect'
import DeviceStatusPanel from './device-status'

interface Iprops {
    type?: number,
    onClose?: () => void
}

export default function InfoDetailPanel(props: Iprops) {
    const { type } = props;

    const onClose = () => {
        if (props.onClose) {
            props.onClose();
        }
    }

    return (
        <div className='info-detail-panel'>
            {/* <div className="close-icon" onClick={onClose}><CloseSvg /></div> */}
            {type == DetailType.OBJECT_DETAIL && (
                <>

                    <ObjectDetailPanel/>
                </>
            )}
            <div className='info-detail-panel-content'>
                {type == DetailType.UPLOAD && <InfoElementPanel />}
                {type == DetailType.INSPECT && <InspectPanel />}
                {type == DetailType.DEVICE_STATUS && <DeviceStatusPanel />}
                {type == DetailType.SEND_TASK && <SendWorkPanel />}
                {type == DetailType.NOTICE && <NoticePanel />}
            </div>


        </div>
    )


}

